import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AnchorElTooltips from './AnchorElTooltips';
import ClientProvider from './client';
export default createDemo(import.meta.url, AnchorElTooltips, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tooltips/demos/anchor-el/AnchorElTooltips.tsx",
    "fileName": "AnchorElTooltips.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tooltip from '@mui/material/Tooltip';\nimport type { Instance } from '@popperjs/core';\n\nexport default function AnchorElTooltips() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const positionRef = React.useRef<{ x: number; y: number }>({\n    x: 0,\n    y: 0,\n  });\n  const popperRef = React.useRef<Instance>(null);\n  const areaRef = React.useRef<HTMLDivElement>(null);\n\n  const handleMouseMove = (event: React.MouseEvent) => {\n    positionRef.current = { x: event.clientX, y: event.clientY };\n\n    if (popperRef.current != null) {\n      popperRef.current.update();\n    }\n  };\n\n  return (\n    <Tooltip\n      describeChild\n      title=\"Add\"\n      placement=\"top\"\n      arrow\n      slotProps={{\n        popper: {\n          popperRef,\n          anchorEl: {\n            getBoundingClientRect: () => {\n              return new DOMRect(\n                positionRef.current.x,\n                areaRef.current!.getBoundingClientRect().y,\n                0,\n                0,\n              );\n            },\n          },\n        },\n      }}\n    >\n      <Box\n        ref={areaRef}\n        onMouseMove={handleMouseMove}\n        sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', p: 2 }}\n      >\n        Hover\n      </Box>\n    </Tooltip>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 53,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tooltip from '@mui/material/Tooltip';\nimport type { Instance } from '@popperjs/core';\n\nexport default function AnchorElTooltips() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const positionRef = React.useRef<{ x: number; y: number }>({\n    x: 0,\n    y: 0,\n  });\n  const popperRef = React.useRef<Instance>(null);\n  const areaRef = React.useRef<HTMLDivElement>(null);\n\n  const handleMouseMove = (event: React.MouseEvent) => {\n    positionRef.current = { x: event.clientX, y: event.clientY };\n\n    if (popperRef.current != null) {\n      popperRef.current.update();\n    }\n  };\n\n  return (\n    <Tooltip\n      describeChild\n      title=\"Add\"\n      placement=\"top\"\n      arrow\n      slotProps={{\n        popper: {\n          popperRef,\n          anchorEl: {\n            getBoundingClientRect: () => {\n              return new DOMRect(\n                positionRef.current.x,\n                areaRef.current!.getBoundingClientRect().y,\n                0,\n                0,\n              );\n            },\n          },\n        },\n      }}\n    >\n      <Box\n        ref={areaRef}\n        onMouseMove={handleMouseMove}\n        sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', p: 2 }}\n      >\n        Hover\n      </Box>\n    </Tooltip>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 53,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Tooltip",
      "@popperjs/core"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
